import { getInitials } from "../../utils/getInitials";

export default function Avatar({ src, name, size = 32, objectFit = "cover", style }) {
  const fontSize = Math.round(size * 0.4);

  if (src) {
    return (
      <img
        src={src}
        alt=""
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit,
          flexShrink: 0,
          background: "var(--surface-secondary)",
          ...style,
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: "var(--surface-secondary)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize,
        fontWeight: 600,
        color: "var(--text-secondary)",
        flexShrink: 0,
        fontFamily: "DM Sans",
        ...style,
      }}
    >
      {getInitials(name)}
    </div>
  );
}
